var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGcpCard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "ic_sync_gcp_storage_card",
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group-9"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Oval"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 24,
    fill: "#f5f5f5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_11040",
    fillRule: "evenodd",
    transform: "translate(-492 -1578.899)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Fill-1",
    fill: "#ea4335",
    d: "M17.128 5.652h.081l-.049-.041 3.063-3.063.006-.055a9.961 9.961 0 0 0-16.2 4.859 1.249 1.249 0 0 1 .16-.052 7.147 7.147 0 0 1 5.324-1.057.093.093 0 0 1 .065-.017 5.526 5.526 0 0 1 7.566-.575h-.016",
    transform: "translate(502.051 1592.398)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-2",
    fill: "#4285f4",
    d: "M26.241 8.124a10.009 10.009 0 0 0-3.009-4.851l-3.111 3.11a5.53 5.53 0 0 1 2.03 4.386v.551c3.69 0 3.69 5.536 0 5.536h-5.537l-.008.009v4.395h-.024l.032.032h5.537a7.2 7.2 0 0 0 4.09-13.168",
    transform: "translate(499.089 1591.626)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-3",
    fill: "#34a853",
    d: "M8.027 25.367h5.535v-4.431H8.027a2.717 2.717 0 0 1-1.137-.249l-3.2 3.2-.008.034a7.169 7.169 0 0 0 4.346 1.446",
    transform: "translate(502.132 1587.519)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-4",
    fill: "#fbbc05",
    d: "M7.159 8a7.2 7.2 0 0 0-4.346 12.9l3.212-3.211a2.768 2.768 0 1 1 3.661-3.663l3.212-3.21A7.194 7.194 0 0 0 7.159 8",
    transform: "translate(503 1590.513)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGcpCard);
export default __webpack_public_path__ + "static/media/gcp-card.a683dc4d1f47d342599cc40c333621bc.svg";
export { ForwardRef as ReactComponent };